// extracted by mini-css-extract-plugin
export var section = "hero-module--section--ZxKgh";
export var inner = "hero-module--inner--D5Y8H";